import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Layout as AntLayout } from 'antd';
import styled from 'styled-components';
var Sider = AntLayout.Sider,
    Content = AntLayout.Content;
var Layout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nwidth: 100%;\ndisplay: flex;\nflex-direction: ", ";\nbackground-color: white;\npadding: ", ";\n\n@media print {\n  padding: 0;\n}\n"])), function (props) {
  return props.hasSider ? 'row' : 'column';
}, function (props) {
  return props.liteMode ? 'unset' : '1rem 0';
}); // workaround to inject Sider and Content as static members of

var Temp = Layout;
Temp.Sider = Sider;
Temp.Content = Content;
export default Temp;